import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class UploadImageService {
  constructor(protected api: BaseApiService) {}

  abstract getImage(): Observable<string>;

  abstract uploadImage(image: File): void;

  abstract uploadImageApi(image: File): Observable<string>;

  abstract getTitle(): string;

  abstract isLoading(): Observable<boolean>;

  abstract uploadDone(): Observable<boolean>;
}
